import WebAPI from './api-calls';

const webApi = new WebAPI();

export async function fetchWaterOverview() {
    const endpoint = '/api/multiutility/water-overview';

    const response = await webApi.getFromWebApiWithAccessTokenAsync(endpoint);

    return response.data; 
}